import { UrlSegment } from '@angular/router';

/**
 * Top-level route families served without a guard, because customers open them straight from an
 * SMS or email link and have no Apruv account: review (including tipping, payment and the v2
 * proof-of-service flow), referral, onboarding and sales registration.
 *
 * These matter to the wildcard in `app.routes.ts`. It sends unmatched URLs to the launcher at
 * `''`, which is behind AuthGuard + RoleGuard, and a redirect is applied *before* guards run — so
 * by the time RoleGuard checks its own public-route escape, `state.url` is already `/` and the
 * escape no longer fires (`roleGuard.service.ts` `isPublicRoute`). A customer on a truncated or
 * stale link would be pushed into the staff Keycloak login, losing the original URL to
 * `redirectUri: origin + '/'`. Anything under these prefixes goes to a public page instead.
 */
export const PUBLIC_LINK_PREFIXES: readonly string[] = [
  'review',
  'referral',
  'onboarding',
  'registration',
];

/**
 * Matched on the whole first segment rather than a string prefix, so a would-be app route such as
 * `/reviewers` is not mistaken for a customer link.
 */
export function isPublicLinkUrl(segments: readonly UrlSegment[]): boolean {
  const firstSegment = segments[0]?.path;
  return !!firstSegment && PUBLIC_LINK_PREFIXES.includes(firstSegment);
}
